import { IMessagingService } from "../services";
import { setCookie } from "../utils";
import { Component } from "./component";

class NotificationComponent extends Component {
    private expires: string;
    private id: string;
    private notification: HTMLElement;
    private onClick: EventListener;

    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        this.id = componentEl.dataset.id;
        this.expires = componentEl.dataset.expires;
        this.notification = componentEl;

        // Events
        this.onClick = this.onClickHandler.bind(this);

        this.init();
    }

    protected async init() {
        this.notification.addEventListener("click", this.onClick);
    }

    private onClickHandler(e) {
        let el = e.target;
        let allEls = [e.target];

        while (el.parentNode) {
            el = el.parentNode;
            allEls.push(el);
        }

        allEls.every((element) => {
            if (typeof element === 'object' && element !== null && 'getAttribute' in element) {
                if (element.getAttribute("data-dismiss") === "notification") {
                    this.hidenotification();
                    return false;
                }
            }

            return true;
        });
    }

    public hidenotification() {

        // Remove events
        this.notification.removeEventListener("click", this.onClick);

        const cookieKey = "notification-" + this.id;

        setTimeout(() => {
            const currentDate: Date = new Date();
            let expiry: Date = new Date();

            switch (this.expires) {
                case "1 month":
                case "OneMonth": {
                    expiry.setMonth(expiry.getMonth() + 1);
                    break;
                }
                case "1 week":
                case "OneWeek": {
                    expiry.setDate(expiry.getDate() + 7);
                    break;
                }
                case "1 day":
                case "OneDay": {
                    expiry.setDate(expiry.getDate() + 1);
                    break;
                }
                default: {
                    expiry = new Date();
                    break;
                }
            }

            let days = Math.floor((expiry.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

            setCookie(cookieKey, "true", days);
            
            this.notification.parentNode.removeChild(this.notification);
        }, 200);

        return this;
    }
}

export { NotificationComponent };
